import { cards } from "@/mocks/trending";

const tagColorClass: Record<string, string> = {
  primary: "bg-primary-500 text-background-50",
  accent: "bg-accent-500 text-background-50",
  secondary: "bg-secondary-600 text-background-50",
};

export default function CardFlow() {
  return (
    <section className="w-full bg-background-100/50 py-12 md:py-16">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        {/* 标题 */}
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4">
          <div>
            <h2 className="flex items-center gap-2 text-2xl md:text-3xl font-black text-foreground-950">
              <span className="w-9 h-9 flex items-center justify-center rounded-xl bg-accent-500 text-background-50">
                <i className="ri-article-line"></i>
              </span>
              热门吃瓜 · 封面速览
            </h2>
            <p className="mt-2 text-sm text-foreground-500">大图卡片流，看到封面就想点进来，围观姿势一次到位。</p>
          </div>
          <div className="flex items-center gap-2 text-sm text-foreground-500">
            <span className="relative flex h-2 w-2">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-accent-500 opacity-75"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-accent-500"></span>
            </span>
            实时收录中
          </div>
        </div>

        {/* 卡片网格 */}
        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {cards.map((c) => (
            <a
              key={c.id}
              href="#top"
              className="group flex flex-col rounded-2xl overflow-hidden border border-background-200/80 bg-background-50 hover:-translate-y-1 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full h-44 md:h-40 overflow-hidden">
                <img
                  src={c.cover}
                  alt={c.title}
                  className="absolute inset-0 h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <span className={`absolute left-3 top-3 rounded-full px-2.5 py-1 text-[11px] font-bold ${tagColorClass[c.tagColor] || tagColorClass.primary}`}>
                  {c.tag}
                </span>
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
              </div>

              <div className="flex flex-1 flex-col p-4">
                <h3 className="text-[15px] font-bold text-foreground-900 leading-snug group-hover:text-primary-600 transition-colors line-clamp-2">
                  {c.title}
                </h3>
                <p className="mt-2 text-xs text-foreground-500 leading-relaxed line-clamp-2">{c.summary}</p>
                <div className="mt-4 flex items-center justify-between pt-3 border-t border-background-100">
                  <span className="text-xs text-foreground-400">{c.time}</span>
                  <div className="flex items-center gap-3 text-xs text-foreground-500">
                    <span className="flex items-center gap-1">
                      <span className="w-3.5 h-3.5 flex items-center justify-center">
                        <i className="ri-eye-line"></i>
                      </span>
                      {c.views}
                    </span>
                    <span className="flex items-center gap-1">
                      <span className="w-3.5 h-3.5 flex items-center justify-center">
                        <i className="ri-chat-3-line"></i>
                      </span>
                      {c.comments.toLocaleString()}
                    </span>
                  </div>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}